export default {
  namespaced: true,
  state: {
    previousRoute: '', //上一个路由
    nextRoute: '' //下一个路由
  },
  actions: {
    /**
     * 设置上一个路由
     */
    setPreviousRoute({ state }, route) {
      state.previousRoute = route
    },
    setNextRoute({ state }, route) {
      state.nextRoute = route
    }
  }
}
